import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { skills } from '../../data/om-mig-data';
export function OmMigSkills() {
  const [activeSkill, setActiveSkill] = useState(skills[0].id);
  return <section className="py-16 md:py-24 px-6 bg-card/40" data-id="element-134">
      <div className="max-w-4xl mx-auto" data-id="element-135">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-136">
          <span className="text-sage font-medium tracking-widest text-xs uppercase mb-3 block" data-id="element-137">
            01 — Kompetenser
          </span>
          <h2 className="text-3xl md:text-4xl font-light text-ink mb-8" data-id="element-138">
            Vad jag faktiskt kan
          </h2>

          {/* Skill Pills */}
          <div className="flex flex-wrap gap-3 mb-8" data-id="element-139">
            {skills.map(skill => <button key={skill.id} onClick={() => setActiveSkill(skill.id)} className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 border ${activeSkill === skill.id ? 'bg-terracotta text-white border-terracotta shadow-md shadow-terracotta/20 scale-105' : 'bg-background text-muted border-border/50 hover:border-terracotta/30 hover:text-ink'}`} data-id="element-140">
                {skill.label}
              </button>)}
          </div>

          {/* Active Skill Description */}
          <div className="min-h-[160px]" data-id="element-141">
            <AnimatePresence mode="wait" data-id="element-142">
              {skills.map(skill => skill.id === activeSkill && <motion.div key={skill.id} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -10
            }} transition={{
              duration: 0.3
            }} className="bg-background rounded-2xl p-8 border border-border/50 shadow-sm" data-id="element-143">
                      <h3 className="text-xl font-medium text-ink mb-3" data-id="element-144">
                        {skill.label}
                      </h3>
                      <p className="text-muted text-lg leading-relaxed" data-id="element-145">
                        {skill.description}
                      </p>
                    </motion.div>)}
            </AnimatePresence>
          </div>
        </motion.div>
      </div>
    </section>;
}